import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import FlagIcon from 'vue-flag-icon'
import axios from 'axios'
import API from './API'
import Store from './Store'
import VueCookies from 'vue-cookies'

function moveToLoginPage(Type) {
  if (Type==1) {
    window.alert("Zostały naruszone zasady bezpieczeństwa !!!")
  }
  sessionStorage.removeItem("TPSession");
  location.reload();
}

axios.defaults.baseURL = 'https://termoprofil.com.pl:5090'; //główna
//axios.defaults.baseURL = 'https://termoprofil.com.pl:5091';  //test



window.axios = axios
window.API = API
window.Store = Store
window.moveToLoginPage = moveToLoginPage

Vue.config.productionTip = false
Vue.use(FlagIcon)
Vue.use(VueCookies)

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

